// SurveyPage.js
import useScrollToTop from '../components/useScrollToTop';
import FAQ from '../components/FAQ';
import surveyFAQData from '../components/surveyFAQData';
import ReusableLanding from '../components/ReusableLanding';
import image1 from '../img/service_landing_img.webp';
import Advantages from '../components/Advantages';
import AboutUspage from '../components/AboutUsPage';
import React from 'react';
import PlotSurveyForm from '../components/PlotSurveyForm';
import CriticalApplications from '../components/CriticalApplications'; // Import the new component
import { FaCheckCircle, FaUsers, FaHome, FaLightbulb, FaPhoneAlt, FaMapMarkedAlt } from 'react-icons/fa'; // Import necessary icons

// Advantages data tailored specifically for land surveying services
const advantagesData = [
  {
    icon: <FaMapMarkedAlt className="text-blue-600 text-3xl mb-2" />, // Replaced with a relevant map icon
    title: 'Precision & Accuracy',
    description: 'Utilizing advanced equipment and methodologies for highly precise two-dimensional and three-dimensional measurements.',
  },
  {
    icon: <FaCheckCircle className="text-blue-600 text-3xl mb-2" />,
    title: 'Legal Compliance',
    description: 'Ensuring all surveys meet local regulations, zoning laws, and legal requirements for clear property boundaries and rights.',
  },
  {
    icon: <FaUsers className="text-blue-600 text-3xl mb-2" />,
    title: 'Expert Team',
    description: 'Our team comprises certified land surveyors and geospatial professionals with extensive field experience and expertise.',
  },
  {
    icon: <FaHome className="text-blue-600 text-3xl mb-2" />,
    title: 'Infrastructure Support',
    description: 'Providing critical data for the accurate planning and execution of roads, buildings, utilities, and major construction projects.',
  },
  {
    icon: <FaLightbulb className="text-blue-600 text-3xl mb-2" />,
    title: 'Urban & Rural Planning',
    description: 'Delivering foundational data for effective urban planning, land development, subdivision, and sustainable resource management.',
  },
  {
    icon: <FaPhoneAlt className="text-blue-600 text-3xl mb-2" />,
    title: 'Comprehensive Reporting',
    description: 'Offering detailed, easy-to-understand survey reports including topographical features, land usage analysis, and recommendations.',
  },
];


const SurveyPage = () => {
  useScrollToTop();

  const pageContainerStyle = {
    minHeight: '100vh',
    background: 'linear-gradient(to bottom right, #e0f2fe, #e0f7fa)', // from-blue-100 to-indigo-200
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Inter, sans-serif',
    color: '#333', // gray-800
  };

  const servicesPageContentStyle = {
    width: '100%',
    maxWidth: '1280px', // max-w-6xl
    margin: '0 auto',
    paddingTop: '32px', // py-8
  };

  // Removed sectionContainerStyle, sectionTitleStyle, sectionDescriptionStyle, gridContainerStyle, subTitleStyle
  // as they are now defined within CriticalApplications.js

  return (
    <>
    <ReusableLanding
          imageUrl={image1}
          title="Precision Land Surveying Services"
          description="Surveying, also known as land surveying, is the technique, profession, art, and science of determining the terrestrial two-dimensional or three-dimensional positions of points and the distances and angles between them. These points are usually on the surface of the Earth. We provide precise and reliable data for all your land measurement needs."
        />
      <div style={pageContainerStyle}>
        <div style={servicesPageContentStyle}>
          {/* About Us Page component, as per user's original structure */}
          <AboutUspage/>

          {/* Critical Applications & Expertise Section - Now using the new component */}
          <CriticalApplications />
        </div>

        {/* Advantages Section using the updated surveying-specific data */}
        <Advantages advantages={advantagesData} />

        {/* Survey Request Form Section - Now using the new component */}
        <PlotSurveyForm />

        
      </div>
      <FAQ faqData={surveyFAQData} />
    </>
  );
};

export default SurveyPage;